import React, { useState, useEffect, useRef } from 'react';

import Button from './Utilities/CustomButton';

import logo from '../assets/images/logo_hocoia.svg';
import '../styles/Start.scss';


export default function Start() {

  const goTo = (eventName) => {
    window.sdk.event().emit(eventName);
  }

  let isPatient = false;
  if (window.sdk.session() && window.sdk.session().session && window.sdk.session().session.name === 'patient') {
    isPatient = true;
  }

  //-------
  return (
    <div className="home-start">
      <div className="home-start__content">
        <div className="home-start__text">Hocoia vous souhaite la bienvenue</div>
        {/* <img src={logo} alt="Logo" className="home-start__logo img-fluid" /> */}
        <div className="home-start__actions">
          {isPatient && (<Button outline={true} className='home-start__action' onClick={() => { goTo('medicalInfo') }}>Remplir le questionnaire médical</Button>)}
          <Button className='home-start__action' onClick={() => { goTo('onBoarding') }}>Se connecter</Button>
        </div>
      </div>
    </div>
  );
}